if (!customElements.get('ms-product-tools')) {
  customElements.define('ms-product-tools', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.product = this.closest('product-info');
      if (!this.product) return;
      this.price = this.querySelector('[data-ms-sticky-price]');
      this.variant = this.querySelector('[data-ms-sticky-variant]');
      this.button = this.querySelector('[data-ms-sticky-submit]');
      this.sync = this.sync.bind(this);
      this.button.addEventListener('click', () => {
        const original = this.product.querySelector('.product-form__submit');
        if (original && !this.button.disabled && !original.disabled && original.getAttribute('aria-disabled') !== 'true') original.click();
      }, { signal: this.controller.signal });
      this.product.addEventListener('change', this.sync, { signal: this.controller.signal });
      this.observer = new MutationObserver(() => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      });
      const info = this.product.querySelector('.product__info-container');
      if (info) this.observer.observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class', 'value'] });
      this.hidden = false;
      this.product.classList.add('ms-has-sticky');
      this.sync();
    }
    sync() {
      if (!this.isConnected) return;
      const original = this.product.querySelector('.product-form__submit');
      if (!original) { this.hidden = true; return; }
      this.hidden = false;
      const priceRoot = this.product.querySelector(`[id="price-${this.dataset.section}"]`);
      const isSale = priceRoot?.querySelector('.price--on-sale');
      const current = priceRoot?.querySelector(isSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
      const priceText = priceRoot?.classList.contains('hidden') ? '' : current?.textContent?.trim() || '';
      if (this.price.textContent !== priceText) this.price.textContent = priceText;
      let selected = '';
      try {
        const json = this.product.querySelector('[data-selected-variant]');
        const value = json ? JSON.parse(json.textContent) : null;
        if (value && value.title !== 'Default Title') selected = value.title || '';
      } catch { selected = ''; }
      if (this.variant.textContent !== selected) this.variant.textContent = selected;
      const buttonText = original.querySelector('span:not(.loading__spinner)')?.textContent?.trim() || original.textContent.trim();
      if (this.button.textContent !== buttonText) this.button.textContent = buttonText;
      this.button.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true' || original.classList.contains('loading');
      this.button.setAttribute('aria-busy', original.classList.contains('loading') ? 'true' : 'false');
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.product?.classList.remove('ms-has-sticky');
    }
  });
}

if (!customElements.get('ms-size-finder')) {
  customElements.define('ms-size-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {
        const data = JSON.parse(this.querySelector('[data-ms-size-data]').textContent);
        this.rows = (data.rows || []).filter((r) => r && r.size && r.foot > 0).sort((a, b) => a.foot - b.foot);
      } catch { this.rows = []; }
      this.input = this.querySelector('[data-ms-foot]');
      this.result = this.querySelector('[data-ms-result]');
      this.querySelector('[data-ms-find]')?.addEventListener('click', () => this.find());
      this.input?.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this.find(); } });
    }
    isSizeOption(name) {
      const n = String(name || '').toLocaleLowerCase('tr');
      return ['beden', 'numara', 'size', 'ölçü'].some((k) => n.includes(k));
    }
    show(nodes) {
      this.result.replaceChildren(...nodes);
      this.result.hidden = false;
    }
    p(text, cls) {
      const el = document.createElement('p');
      if (cls) el.className = cls;
      el.textContent = text;
      return el;
    }
    find() {
      const value = parseFloat(String(this.input?.value || '').replace(',', '.'));
      this.querySelectorAll('tr.is-match').forEach((tr) => tr.classList.remove('is-match'));
      if (!this.rows.length) return;
      if (!value || value < 15 || value > 35) {
        this.show([this.p('Lütfen ayak uzunluğunuzu santimetre olarak girin (ör. 24,5).', 'ms-size-finder__warn')]);
        this.input?.focus();
        return;
      }
      let match = this.rows.find((r) => r.foot >= value - 0.05);
      const nodes = [];
      if (!match) {
        match = this.rows[this.rows.length - 1];
        nodes.push(this.p('Ölçünüz tablodaki en uzun ölçüden büyük. Sipariş vermeden önce bize yazmanızı öneririz.', 'ms-size-finder__warn'));
      } else if (match === this.rows[0] && value < match.foot - 1) {
        nodes.push(this.p('Ölçünüz tablodaki en kısa ölçüden küçük; en küçük numarayı gösteriyoruz.', 'ms-size-finder__warn'));
      }
      const head = document.createElement('p');
      head.className = 'ms-size-finder__pick';
      head.append('Önerilen numara: ');
      const strong = document.createElement('strong');
      strong.textContent = match.size;
      head.append(strong);
      nodes.unshift(head);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'button';
      btn.textContent = `${match.size} numarayı seç`;
      btn.addEventListener('click', () => this.select(String(match.size)));
      nodes.push(btn);
      this.show(nodes);
      this.querySelectorAll('tbody th[scope=row]').forEach((th) => {
        if (th.textContent.trim() === String(match.size)) th.closest('tr')?.classList.add('is-match');
      });
    }
    select(size) {
      const root = this.closest('product-info') || document;
      const selects = root.querySelector('variant-selects');
      if (!selects) return;
      const radio = [...selects.querySelectorAll('input[type=radio]')].find(
        (i) => this.isSizeOption(i.dataset.optionName) && i.value.trim() === size
      );
      if (radio) {
        const group = radio.closest('details');
        if (group) group.open = true;
        if (radio.classList.contains('disabled')) {
          this.show([this.p(`${size} numara seçili renkte şu an tükendi. Başka bir renk seçebilirsiniz.`, 'ms-size-finder__warn')]);
        }
        if (!radio.checked) radio.click();
        radio.closest('fieldset')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      const select = [...selects.querySelectorAll('select')].find((s) =>
        [...s.options].some((o) => this.isSizeOption(o.dataset.optionName) && o.value.trim() === size)
      );
      if (select) {
        select.value = [...select.options].find((o) => o.value.trim() === size).value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        select.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      this.show([this.p('Bu numara bu üründe bulunamadı.', 'ms-size-finder__warn')]);
    }
  });
}
